export default (id = ':id') => `/payment-groups/${id}`;
